import {forwardRef} from 'react';

import {twx} from '@/utils/tailwindUtils';
import Icon from '../Icon/Icon';

type BackButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
};

const ChevronLeftIcon = ({className}: {className?: string}) => (
    <Icon width='24' height='24' fill='none' className={className}>
        <path d='M14.8979 4L7.12915 11.7419' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M7.12891 11.7419L14.8977 19.5107' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </Icon>
);

const BackButton = forwardRef<HTMLButtonElement, BackButtonProps>(
    ({className, icon, 'aria-label': ariaLabel = 'Back', ...restProps}, ref) => (
        <button
            type='button'
            ref={ref}
            className={twx(
                'flex h-10 w-10 items-center justify-center rounded-full border-0 text-white outline-none',
                'bg-tips-surface-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tips-button-ring',
                className
            )}
            aria-label={ariaLabel}
            {...restProps}
        >
            {icon ?? <ChevronLeftIcon />}
        </button>
    )
);

BackButton.displayName = 'BackButton';

export default BackButton;
